import React from "react";
import "../css/ApproveModal.css";
import { CircularProgress } from "@mui/material";

const ApproveModal = ({
  email,
  tripId,
  timestamp,
  onApprove,
  isLoading,
  message,
  airport,
}) => {
  return (
    <div className="approve-modal">
      <h2 className="approve-heading" data-testid="approve-heading">Approve</h2>
      <p className="approve-text" data-testid="approve-text">{message}</p>

      <button className="approve-button" onClick={onApprove} data-testid="approve-button-confirm">
        {isLoading ? <CircularProgress size={20} color="inherit" /> : "Yes"}
      </button>
    </div>
  );
};

export default ApproveModal;
